import { AxiosError, AxiosResponse } from 'axios'

/**
 * 通信エラーからステータスコードを取得する。
 * @param reason 通信エラー、またはその他のエラー
 * @return {number | undefined}
 */
export default function getStatusCode(reason: any): number | undefined {
  const response = reason ? (<AxiosError>reason).response : undefined
  return response ? (<AxiosResponse>response).status : undefined
}

export function isUnauthorized(reason: any): boolean {
  return getStatusCode(reason) === 401
}

export function isSizeLimitExceeded(reason: any): boolean {
  return getStatusCode(reason) === 402
}

export function isNotFound(reason: any): boolean {
  return getStatusCode(reason) === 404
}

export function isRequestSizeOver(reason: any): boolean {
  return getStatusCode(reason) === 413
}

export function isUnsupportedMediaType(reason: any): boolean {
  return getStatusCode(reason) === 415
}

export function isTeaPot(reason: any): boolean {
  return getStatusCode(reason) === 418
}

export function isRetryableError(reason: any): boolean {
  const status = getStatusCode(reason)
  return !status || (status >= 500 && status < 600)
}
